import React from 'react';
import GeoPageTemplate from '../components/GeoPageTemplate';
import geoConfigs from '../config/geoConfigs';

const LocacaoBetim = () => {
  return <GeoPageTemplate {...geoConfigs.betim} />;
};

export default LocacaoBetim;